<div class="banner__content col-12 col-lg-7">
  <div class="row">
    <div class="banner__actions col-12 ">
      <div
        [ngClass]="show ? 'banner__sub banner__sub--inactive d-flex align-items-start':'banner__sub banner__sub--active d-flex align-items-start'"
        (click)="toggle()">
        <img class="mr-2" src="assets/img/id.png" alt="">
        <h3>Solicitar</h3>
      </div>
      <div [ngClass]="show ? 'animation-container--closed' : 'animation-container'">
        <div class="banner__list banner__list--show  ">
          <div class="col-12 col-lg-12">
            <div class="banner__action mt-2" routerLink="/license/new">
              <h5>Crear solicitud nueva licencia</h5>
              <p>Formulario para empleados y contratistas.<p>
            </div>
            <div class="banner__action mt-2" routerLink="/license/renew">
              <h5>Renovar licencia</h5>
              <p>Acceso para renovar documentos o contrato.<p>
            </div>
            <div class="banner__action mt-2" routerLink="/license/extend">
              <h5>Ampliar licencia</h5>
              <p>Formulario para modificar equipos registrados.<p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <p class="info-banner">Despliega las categorías para acceder a las funciones del portal.</p>
</div>
